import { FunctionComponent } from 'react';

// Components
import Image from '@Components/Utils/Image';
import Anchor from '@Components/Utils/Anchor';
import EmptySchedule from '@Components/Layout/Components/EmptySchedule';
import NotificationComponent from '@Pages/thong-bao/Components/Notification';

// Utils
import host from '@Config/host';
import classnames from 'classnames';

// Contexts
import { useAppStore } from '@Components/AppStore/Context';
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Styles
import styles from './Notification.module.scss';

// Icons
import { useNotification } from '@Libs/api/user/notification';

interface NotificationProps {
    className?: string;
    bodyClassName?: string;
    scheduleWrapperClassname?: string;
    notificationWrapperClassName?: string;
}

const Notification: FunctionComponent<NotificationProps> = (props) => {
    const { countNotification } = useAppStore();
    const { deviceType } = useViewDetected();

    const { data: notificationService } = useNotification('key', {
        offset: 0,
        limit: 6,
        types: ['service_booking'],
    });
    const notifications = notificationService?.notifications || [];

    const renderEmptyUI = () => {
        return (
            <EmptySchedule
                title="Bạn chưa có lịch hẹn"
                btnText="Đặt lịch hẹn khám"
                className={styles.schedule_empty}
                href={`${host.homeDomain}/dich-vu`}
                description="Hãy thêm lịch hẹn để chăm sóc sức khỏe của bạn ngay bây giờ"
            />
        );
    };

    const renderItemMenu = () => {
        return notifications.map((item, index) => {
            return <NotificationComponent data={item?.data} key={index} id={item?.id} text={item?.message} isRead={item?.read?.status === 1} type={item?.data?.type} className={styles.notification} />;
        });
    };

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const bodyClassName = classnames([
        styles.body,
        props.bodyClassName,
        {
            [styles.body_empty]: notifications?.length === 0,
        },
    ]);
    const scheduleWrapperClassName = classnames([styles.schedule_wrapper, props.scheduleWrapperClassname]);
    const notificationWrapperClassName = classnames([styles.notification_wrapper, props.notificationWrapperClassName]);

    return (
        <div className={className}>
            <div className={bodyClassName}>
                <div className={notificationWrapperClassName}>
                    <Anchor href={'/thong-bao/tu-van'} className={styles.notification_item}>
                        <Image src="/assets/navbar/doctor_chat.png" className={styles.image} width={'48px'} height={'48px'} />
                        <div className={styles.notification_content}>
                            <span className={styles.title}>
                                Tư vấn
                                {countNotification.question > 0 && <span>{countNotification.question}</span>}
                            </span>
                            <span className={styles.content}>Xem ngay phản hồi của bác sĩ</span>
                        </div>
                    </Anchor>
                    <Anchor href={'/thong-bao/tin-tuc'} className={styles.notification_item}>
                        <Image src="/assets/navbar/health_news.png" className={styles.image} width={'48px'} height={'48px'} />
                        <div className={styles.notification_content}>
                            <span className={styles.title}>
                                Tin tức sức khỏe
                                {countNotification.article > 0 && <span>{countNotification.article}</span>}
                            </span>
                            <span className={styles.content}>Bạn bỏ lỡ tin tức về sức khỏe và Y tế ?</span>
                        </div>
                    </Anchor>
                    <Anchor href={'/thong-bao/khuyen-mai'} className={styles.notification_item}>
                        <Image src="/assets/navbar/promotion.png" className={styles.image} width={'48px'} height={'48px'} />
                        <div className={styles.notification_content}>
                            <span className={styles.title}>
                                Khuyến mãi
                                {countNotification.promotion > 0 && <span>{countNotification.promotion}</span>}
                            </span>
                            <span className={styles.content}>Tin tức khuyến mãi và ưu đãi mới nhất</span>
                        </div>
                    </Anchor>
                </div>
                <div className={scheduleWrapperClassName}>
                    <span className={styles.schedule_title}>Cập nhật đơn hàng & lịch hẹn</span>
                    {notifications?.length > 0 ? (
                        <>
                            <div className={styles.schedule_notifications}>{renderItemMenu()}</div>
                            <Anchor href={'/thong-bao/lich-hen'} className={styles.btn_view_more}>
                                Xem tất cả
                            </Anchor>
                        </>
                    ) : (
                        renderEmptyUI()
                    )}
                </div>
            </div>
        </div>
    );
};

Notification.defaultProps = {
    className: '',
};

export default Notification;
